import { useSuspenseQuery } from "@tanstack/react-query";
import { Api } from "../api.config";
import { useCompany } from "../company/useCompany";
import { QueryKeys } from "../LinkGen";

export const useMetaAdsAds = (adSetId: string, from: string, to: string) => {
	const company = useCompany();
	return useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Reporting.AdSetAds(
			company.id,
			adSetId,
			from,
			to,
		),
		queryFn: () =>
			Api.GetMetaAdsAdSetAds(adSetId, from, to).then((r) => r.data),
	});
};
